import { LoaderPlugin } from '@jollywise/jollygoodgame';

export class LoaderPluginSesame extends LoaderPlugin {
  constructor(...args) {
    super(...args);
    this._locale = 'en';
  }

  set locale(value) {
    this._locale = value;
  }

  loadAssetPack(pack, keys, onComplete) {
    pack = this._localisePack(pack);
    console.log('LOAD ASSETPACK', pack);
    super.loadAssetPack(pack, keys, onComplete);
  }

  bootGame(config, onComplete, paths) {
    const localConfig = { boot: {}, load: {} };
    localConfig.boot.assetpacks = config.boot.assetpacks.map((pack) => {
      return { config: this._localisePack(pack.config), keys: [...pack.keys] };
    });
    localConfig.load.assetpacks = config.load.assetpacks.map((pack) => {
      return { config: this._localisePack(pack.config), keys: [...pack.keys] };
    });

    super.bootGame(localConfig, onComplete, paths);
  }

  _localisePack = (pack) => {
    const localpack = JSON.parse(JSON.stringify(pack));
    Object.keys(pack).forEach((key) => {
      if (localpack[key].path_local && localpack[key].path_local[this._locale]) {
        localpack[key].path = localpack[key].path_local[this._locale];
      }
    });
    return localpack;
  };
}
